import Vue from "vue";
import Helper from "./helper";
import Faker from "./faker";
import Lodash from "./lodash";

Vue.use(Helper);
Vue.use(Faker);
Vue.use(Lodash);
